export default __webpack_public_path__ + "static/media/money-bag.00ced2bc.png";